import React from 'react'
import { Navigate } from 'react-router-dom'
export const  ProtectedRoute = ({ isSignedIn, path, children }) => {
  if (!isSignedIn) {
    return <Navigate to={path} replace />
  }
  return children
}